(function($) {

    $.fn.msxiTableTrimmer = function(options) {
        // build main options before element iteration
        var opts = $.extend( {}, $.fn.msxiTableTrimmer.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // only init if not already expanded and less than 500 rows. Above 500 rows the performance will be very poor.
            var rowCount = $(this).find('tr').size();
            if (!$(this).data('expanded') && rowCount <= 500) {
                // build element specific options
                var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
                eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

                // Take into account hidden form fields
                var trim = $this.find('.include-in-trim');
                trim.show();

                // Thumbnail and indicator images may not have loaded yet so make sure enough space is reserved
                var $thumbs = $this.find('td.thumbnail img');
                $thumbs.width(48);
                var $indicator = $this.find('td.indicator img');
                $indicator.width(16);
                // Temporarily remove nowrap-ellipsis class so that columns can be cropped
                var $nowrapEllipsis = $this.find('td.nowrap-ellipsis');
                $nowrapEllipsis.removeClass('nowrap-ellipsis');

                // for tables over 100 rows we run a reduced feature set to improve performance
                var largeTable = rowCount > 100;
                var $cols = $this.find('col');
                var $firstRow = $this.children('tbody,tfoot').children('tr').not('.row-group').not('.description-row').filter(':first');

                var $parent = $this.parent();
                var targetWidth = $parent.width();
                if ($parent.css('overflow-y') == 'auto') {
                    // allow extra space for scrollbar
                    targetWidth = targetWidth - 18;
                }
                // If there is no target width then columns will only be trimmed if they are larger than column max-width
                var noTargetWidth = $this.hasClass('no-target-width');

                var cellsByRow = {};
                var rows = $this.find('tr').not('.filters').not('.detail-row');
                $cols.each(function(i){
                    cellsByRow[i] = rows.children(':nth-child(' + (i+1) + ')');
                });

                // If the existing table is equal to or greater than the size of the container then we will ensure the table fills the container even if the columns don't need all the width.
                // -1 is used to account for rounding error with percentages and ems.
                var fluid = $this.width() - targetWidth >= -1;

                // Set the table to its preferred width
                $this.css('width', 'auto');

                // Reset text in cells if already trimmed
                $cols.each(function(i){
                    var $col = $(this);
                    $col.filter('.trim').each(function(){
                        var $cells = cellsByRow[i];
                        resetCellTitles($cells);
                    });
                });

                // Calculate preferred/min/max widths
                var preferredTotalWidth = 0;
                $cols.each(function(i){
                    var $col = $(this);
                    $col.data('i', i);
                    var $firstCell = $firstRow.children(':nth-child(' + (i+1) + ')');
                    var preferredWidth = $firstCell.outerWidth();
                    // Can't figure out why thumbnail columns are not calculating width correctly, so this is a workaround
                    if($firstCell.is('.thumbnail')) {
                        preferredWidth = Math.max(70, preferredWidth);
                    }
                    else if($firstCell.is('.indicator')) {
                        preferredWidth = Math.max(16, preferredWidth);
                    }
                    var minWidth = parseInt($col.css('min-width'), 10);
                    var maxWidth = $col.css('max-width') != 'none' ? parseInt($col.css('max-width')) : preferredWidth;

                    // Min width overrides preferred width if it is larger
                    preferredWidth = Math.max(minWidth, preferredWidth);
                    $col.data('preferred-width', preferredWidth);
                    $col.data('min-width', minWidth);
                    $col.data('max-width', maxWidth);

                    preferredTotalWidth += $col.data('preferred-width');
                });

                var usedWidth = 0;

                // 1. if total preferred width is less than the target width then we don't need to trim anything.
                // Distribute the columns proportionally, only trimming columns with max-width or must-trim
                if(!noTargetWidth && preferredTotalWidth < targetWidth) {
                    var additionalWidth = targetWidth - preferredTotalWidth;
                    $cols.each(function(){
                        var $col = $(this);
                        var preferredWidth = $col.data('preferred-width');
                        var proportionalWidth = preferredWidth + ((preferredWidth/preferredTotalWidth) * additionalWidth);
                        if($col.is('.must-trim')) {
                            debug("preferred width less than target width, but .most-trim: trimColumn", $col);
                            trimColumn($col, proportionalWidth);
                        }
                        else {
                            var maxWidth = $col.data('max-width');
                            if (maxWidth < preferredWidth && maxWidth < proportionalWidth) {
                                debug("preferred width less than target width, but maxWidth < preferredWidth: trimColumn", $col);
                                trimColumn($col, maxWidth);
                            }
                            else {
                                debug("preferred width less than target width: dontTrimColumn", $col);
                                dontTrimColumn($col, proportionalWidth);
                            }
                        }
                    });
                }
                else {

                    // 2. Columns that do not support trim will be set to their preferred width
                    $cols.not('.trim').each(function (i) {
                        var $col = $(this);
                        var preferredWidth = $col.data('preferred-width');
                        debug("column does not support trim: dontTrimColumn", $col);
                        dontTrimColumn($col, preferredWidth);
                    });

                    // 3. Tables with no target width are not constrained by the width of the container.
                    // Only trim columns that have a max-width or must-trim.
                    if (noTargetWidth) {
                        $cols.each(function () {
                            var $col = $(this);
                            var preferredWidth = $col.data('preferred-width');
                            if($col.is('.must-trim')) {
                                debug("table with no target width, but .most-trim: trimColumn", $col);
                                trimColumn($col, preferredWidth);
                            }
                            else {
                                var maxWidth = $col.data('max-width');
                                if (maxWidth < preferredWidth) {
                                    debug("table with no target width, but but maxWidth < preferredWidth: trimColumn", $col);
                                    trimColumn($col, maxWidth);
                                }
                                else if ($col.is(':not(.must-trim)')) {
                                    debug("table with no target width: dontTrimColumn", $col);
                                    dontTrimColumn($col, preferredWidth);
                                }
                            }
                        });
                    }
                    else {

                        // 3. Columns that are small enough to fit without trimming or that have a min-width that would be broken by trimming

                        // Work out how much space is left and divide by the remaining columns. Any columns less wide than the
                        // space available per column will get set to their preferred width. Keep looping until all remaining
                        // columns are wider than the space availble per column (or until there is one column left if using a fluid layout).
                        var remainingWidth = targetWidth - usedWidth;
                        var proposedWidth = 100;
                        var colCount = -1;
                        while (colCount != $cols.size() && remainingWidth > 0) {
                            colCount = $cols.size();
                            proposedWidth = parseInt(remainingWidth / $cols.size(), 10);
                            $($cols.get().reverse()).each(function (i) {
                                var $col = $(this);
                                var preferredWidth = $col.data('preferred-width');
                                var minWidth = $col.data('min-width');
                                if ($col.is(':not(.must-trim):not(.fill)') && (!fluid || $cols.size() > 1) && preferredWidth < proposedWidth) {
                                    var maxWidth = $col.data('max-width');
                                    if (maxWidth < preferredWidth) {
                                        debug("preferredWidth < proposedWidth, but maxWidth < preferredWidth: trimColumn", $col);
                                        trimColumn($col, maxWidth);
                                    }
                                    else {
                                        debug("preferredWidth < proposedWidth: dontTrimColumn", $col);
                                        dontTrimColumn($col, preferredWidth);
                                    }
                                }
                                else if ((!fluid || $cols.size() > 1) && minWidth > proposedWidth) {
                                    debug("preferredWidth >= proposedWidth: trimColumn", $col);
                                    trimColumn($col, minWidth);
                                }
                            });
                            remainingWidth = targetWidth - usedWidth;
                        }
                    }

                    // 4. Columns that require trimming

                    // Any remaining columns share the remaining space and will require trimming
                    $cols.each(function () {
                        var $col = $(this);
                        debug("share remaining space: trimColumn", $col);
                        trimColumn($col, proposedWidth);
                    });
                }
                
                // Now handle any detail rows. These have colspans so are handled separately to other rows
                // Reset cols collection
                $cols = $this.find('col');
                var $detailRows = $this.find('tr.detail-row');
                if($detailRows.length > 0) {
                    var detailColumns = $detailRows.eq(0).children().length;
                    var runningColspan = 0;
                    for (var i = 0; i < detailColumns; i++) {
                        runningColspan = handleDetailColumn(i, runningColspan);
                    }
                }

                if (fluid) {
                    var $dialog = $this.parents('.ui-dialog');
                    if ($dialog.length == 0) {
                        $this.css('width', '100%');
                    } else {
                        $this.width(targetWidth);
                        // Not sure why overflow is needed
                        $dialog.css('overflow-x', 'hidden');
                    }
                }
                else
                {
                    var totalWidth = 0;
                    $cols.each(function(){
                        var $col = $(this);
                        totalWidth += $col.width();
                    });
                    $this.css('width', totalWidth);
                }
                $this.css('table-layout', 'fixed');

                $this.data('expanded', true);

                // Revert temporary changes
                trim.hide();
                $thumbs.width('');
                $indicator.width('');
                $nowrapEllipsis.addClass('nowrap-ellipsis');
            }

            function trimColumn($col, width) {
                var $cells = cellsByRow[$col.data('i')];
                if (!largeTable) {

                    // Ensure all cells have a title
                    createCellTitles($cells);

                    // If the span is less wide than the new column width then this cell will not be trimmed so remove the title
                    if ($col.is('.trim:not(.must-trim)')) {
                        var padding = $cells.eq(0).outerWidth() - $cells.eq(0).width();
                        removeCellTitles($cells, width, padding);
                    }
                }
                debug('setting column width to ' + width + 'px', $col);
                $col.width(width);
                usedWidth = usedWidth + width;
                // Trim!
                $cells.css({'overflow': 'hidden', 'text-overflow': 'ellipsis'});
                $cols = $cols.not($col);
            }

            function dontTrimColumn($col, width) {
                debug('setting column width to ' + width + 'px', $col);
                $col.width(width);
                usedWidth = usedWidth + width;
                if (!largeTable && $col.is('.trim')) {
                    cellsByRow[$col.data('i')].find('a[title], span[title]').not('.ignore-in-trim').removeAttr('title');
                }
                $cols = $cols.not($col);
            }

            function handleDetailColumn(detailcolindex, runningColspan) {
                var $detailCells = $detailRows.children(':nth-child('+(detailcolindex+1)+')');
                var preferredDetailColumnWidth = 0;
                var proposedDetailColumnWidth = 0;
                var detailColspan = ($detailCells.eq(0).attr('colspan') || 1)*1;
                for (var colindex = runningColspan; colindex < detailColspan+runningColspan; colindex++) {
                    preferredDetailColumnWidth = preferredDetailColumnWidth + $cols.eq(colindex).data('preferred-width');
                    proposedDetailColumnWidth = proposedDetailColumnWidth + $cols.eq(colindex).width();
                }

                // Reset text in cells if already trimmed
                resetCellTitles($detailCells);

                // Ensure all cells have a title
                createCellTitles($detailCells);

                // If the span is less wide than the new column width then this cell will not be trimmed so remove the title
                var padding = $detailCells.eq(0).outerWidth() - $detailCells.eq(0).width();
                removeCellTitles($detailCells, proposedDetailColumnWidth, padding);

                // Trim!
                $detailCells.css({'overflow': 'hidden', 'text-overflow': 'ellipsis'});

                return runningColspan + detailColspan;
            }

            /**
             *A cell may already contain trimmed text, in which case we can get the full text from the title attr.
             */
            function resetCellTitles($cells) {
                $cells.each(function () {
                    var $cell = $(this);
                    var $title = $cell.find('a[title], span[title]').not('.ignore-in-trim');
                    var title;
                    if ($title.length == 1) {
                        title = $title.attr('title');
                        $title.text(title);
                    } else {
                        title = $.trim($cell.not(':input').text());
                    }
                    $cell.data('title', title);
                });
            }

            /**
             * Ensure that all cells have a title, ready for trimming
             */
            function createCellTitles($cells) {
                $cells.each(function (i) {
                    var $cell = $(this);
                    var $title = $cell.find('a[title], span[title]').not('.ignore-in-trim');
                    if ($title.length != 1) {
                        $title = $('<span />');
                        $title.attr('title', $cell.data('title'));
                        $cell.contents().wrapAll($title);
                    }
                });
            }

            /**
             * Remove titles from cells that do not need trimming
             */
            function removeCellTitles($cells, width, padding) {
                // If the span is less wide than the new column width then this cell will not be trimmed so remove the title
                $cells.find('a[title], span[title]').not('.ignore-in-trim').filter(function () {
                    return $(this).width() + padding <= width;
                }).removeAttr('title');
            }

            function debug(action, $col)
            {
                logger(action, $col, 'debug');
            }

            function trace(action, $col)
            {
                logger(action, $col, 'trace');
            }

            function logger(action, $col, level)
            {
                if(eOpts[level]) {
                    log(action + ', col{i:'  + $col.data('i') + ', name:"' + $col.closest('table').find('thead tr th').eq($col.data('i')).text().trim() + '"}');
                }
            }
        });
    };

    //
    // plugin defaults
    //
    $.fn.msxiTableTrimmer.defaults = {
        debug: false,
        trace: false
    };

})(jQuery);
